export default "__VITE_ASSET__bf562535__"